<template>
  <!-- .profile -->
  <div class="company-profile-page">
    <div class="container edit-user-template">
      <h1 class="page-header color-1-100">
        <template v-if="canEditDetails">
          Edit account settings
        </template>
        <template v-else>
          Account settings
        </template>
      </h1>
      <div class="flex-block">
        <div class="content-right-section anchors">
          <div class="sticky-anchors background-1-40-before" tabindex="-1">
            <div class="anchor-item anchor-item-custom color-1-20 details"
                 :class="[{ 'active  color-1-100': activeSection === 'companyDetails' }]">
              <a href="#" @click.prevent="goToPageSection('companyDetails')">
                <span class="anchor-item-icon color-1-40">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="19.667" viewBox="0 0 25 19.667">
                    <path id="organisation-details" d="M-12186.666-8295.333h-18.667A2.669,2.669,0,0,1-12208-8298v-13.333a2.669,2.669,0,0,1,2.666-2.667h18.667a2.67,2.67,0,0,1,2.667,2.667V-8298A2.67,2.67,0,0,1-12186.666-8295.333Zm-13.6-6.667a1,1,0,0,1,1,1v1.666h2.333a.667.667,0,0,0,.667-.666v-9a1,1,0,0,0-1-1h-6a1,1,0,0,0-1,1v9a.667.667,0,0,0,.667.666h2.333V-8301A1,1,0,0,1-12200.268-8302Zm7.6-1.334a.668.668,0,0,0-.666.667.667.667,0,0,0,.666.667h5.333a.667.667,0,0,0,.667-.667.668.668,0,0,0-.667-.667Zm0-2.666a.667.667,0,0,0-.666.667.667.667,0,0,0,.666.666h5.333a.667.667,0,0,0,.667-.666.667.667,0,0,0-.667-.667Zm0-2.667a.667.667,0,0,0-.666.667.667.667,0,0,0,.666.667h5.333a.667.667,0,0,0,.667-.667.667.667,0,0,0-.667-.667Zm-5.935,5.333h-.667a.333.333,0,0,1-.333-.333v-.667a.334.334,0,0,1,.333-.333h.667a.33.33,0,0,1,.333.333v.667A.334.334,0,0,1-12198.6-8303.334Zm-2.667,0h-.667a.334.334,0,0,1-.333-.333v-.667a.335.335,0,0,1,.333-.333h.667a.33.33,0,0,1,.333.333v.667A.333.333,0,0,1-12201.268-8303.334Zm2.667-2h-.667a.334.334,0,0,1-.333-.334v-.666a.334.334,0,0,1,.333-.334h.667a.331.331,0,0,1,.333.334v.666A.335.335,0,0,1-12198.6-8305.333Zm-2.667,0h-.667a.335.335,0,0,1-.333-.334v-.666a.335.335,0,0,1,.333-.334h.667a.331.331,0,0,1,.333.334v.666A.334.334,0,0,1-12201.268-8305.333Zm2.667-2.021h-.667a.328.328,0,0,1-.333-.313v-.666a.334.334,0,0,1,.333-.334h.667a.335.335,0,0,1,.333.334v.666A.316.316,0,0,1-12198.6-8307.354Zm-2.667,0h-.667a.329.329,0,0,1-.333-.313v-.666a.335.335,0,0,1,.333-.334h.667a.334.334,0,0,1,.333.334v.666A.316.316,0,0,1-12201.268-8307.354Z" transform="translate(12208.499 8314.5)" fill="currentColor" stroke="rgba(0,0,0,0)" stroke-width="1"/>
                  </svg>
                </span>
                <template v-if="canEditDetails === false">Organisation details</template>
                <template v-else>Edit organisation details</template>
              </a>
            </div>
            <div class="anchor-item anchor-item-custom color-1-20 owner"
                 :class="[{ 'active  color-1-100': activeSection === 'companyOwner' }]">
              <a href="#" @click.prevent="goToPageSection('companyOwner')">
                <span class="anchor-item-icon color-1-40">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 10 20" style="enable-background:new 0 0 10 20;" xml:space="preserve">
                    <g id="XMLID_1_">
                      <circle id="XMLID_2_" class="st0" cx="5" cy="3" r="3"/>
                      <path id="XMLID_3_" class="st0" d="M5,6c-2.757,0-5,2.243-5,5v3c0,0.552,0.448,1,1,1h1v4c0,0.552,0.448,1,1,1h4
                        c0.552,0,1-0.448,1-1v-4h1c0.552,0,1-0.448,1-1v-3C10,8.243,7.757,6,5,6z"/>
                    </g>
                  </svg>
                </span>
                <template v-if="canEditOwner === false">Account owner details</template>
                <template v-else>Edit account owner details</template>
              </a>
            </div>
            <div class="anchor-item anchor-item-custom color-1-20 owner"
                 :class="[{ 'active  color-1-100': activeSection === 'tasksSettings' }]">
              <a href="#" @click.prevent="goToPageSection('tasksSettings')">
                <span class="anchor-item-icon color-1-40">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26.411" height="19.751" viewBox="0 0 26.411 19.751">
                    <path id="task_settings" data-name="task settings" d="M-12206.906-8295.249a1.171,1.171,0,0,1-1.094-1.158,1.109,1.109,0,0,1,1.094-1.094h13.53a1.127,1.127,0,0,1,1.127,1.124,1.128,1.128,0,0,1-1.127,1.128Zm14.746-5.626h0Zm-12.5,0a1.125,1.125,0,0,1-1.094-1.127,1.126,1.126,0,0,1,1.094-1.125h10.258a9.02,9.02,0,0,0,2.239,2.252Zm15.156-1.253a.378.378,0,0,1-.294-.373v-1.263a4.446,4.446,0,0,1-1.422-.818l-1.094.632a.378.378,0,0,1-.2.052c-.512,0-1.5-1.991-1.5-2.319a.386.386,0,0,1,.192-.331l1.091-.631a4.539,4.539,0,0,1-.076-.821,4.588,4.588,0,0,1,.076-.821l-1.091-.631a.382.382,0,0,1-.192-.328c0-.4,1.035-2.322,1.5-2.322a.408.408,0,0,1,.2.052l1.094.632a4.558,4.558,0,0,1,1.422-.818v-1.263a.379.379,0,0,1,.294-.37,5.771,5.771,0,0,1,1.207-.129,5.75,5.75,0,0,1,1.2.129.376.376,0,0,1,.295.37v1.263a4.542,4.542,0,0,1,1.421.818l1.1-.632a.389.389,0,0,1,.192-.052c.512,0,1.5,1.991,1.5,2.322a.39.39,0,0,1-.192.331l-1.091.631a4.692,4.692,0,0,1,.076.818,4.725,4.725,0,0,1-.076.821l1.091.631a.386.386,0,0,1,.192.331c0,.4-1.035,2.319-1.5,2.319a.36.36,0,0,1-.192-.052l-1.1-.632a4.494,4.494,0,0,1-1.421.821v1.263a.4.4,0,0,1-.316.37,5.906,5.906,0,0,1-1.2.129A5.932,5.932,0,0,1-12189.5-8302.128Zm-.668-5.873a1.875,1.875,0,0,0,1.875,1.875,1.878,1.878,0,0,0,1.876-1.875,1.879,1.879,0,0,0-1.876-1.875A1.877,1.877,0,0,0-12190.169-8308Zm-5.661,1.5h-11.076a1.17,1.17,0,0,1-1.094-1.158,1.109,1.109,0,0,1,1.094-1.094h10.92c-.007.178-.013.337-.013.5a9.039,9.039,0,0,0,.172,1.752Z" transform="translate(12208.5 8314.5)" fill="currentColor" stroke="rgba(0,0,0,0)" stroke-width="1"/>
                  </svg>
                </span>
                <template v-if="canEditTasksSettings === false">Task settings</template>
                <template v-else>Edit task settings</template>
              </a>
            </div>
          </div>
        </div>
        <div class="content-left-section">
          <div class="content-section profile-section no-margin-top"
               :class="[{ 'content-section__bordered border-1-20': activeSection === 'companyDetails' || canEditDetails }]"
               tabindex="-1"
               ref="companyDetails">
            <article class="personal-info">
              <h3 class="content-section-title color-1-100 background-1-100-before">
                <template v-if="canEditDetails === false">Organisation details</template>
                <template v-else>Edit organisation details</template>
              </h3>
              <a href="#" v-on:click.prevent="openEditDetails()" class="edit-details edit-details-custom border-1-40 color-2-100"
                 v-if="canEditDetails === false && (getUserRole === 'ca' || getUserRole === 'ta')">
                  <span class="edit-icon color-1-100">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 12.955 12.921" style="enable-background:new 0 0 12.955 12.921;" xml:space="preserve">
                      <g id="XMLID_1_">
                        <path id="XMLID_4_" class="st0" d="M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921
                          c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"/>
                        <path id="XMLID_5_" class="st0" d="M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316
                          L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0
                          l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"/>
                      </g>
                    </svg>
                  </span>
                Edit
              </a>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="new-company-name" class="form-label color-2-63">Organisation name</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': canEditDetails && errors.has('Company name'), 'is-locked': !canEditDetails, 'not-empty': company.details.name !== '' }]"
                         :disabled="canEditDetails === false"
                         data-lpignore="true"
                         v-on:keyup="fieldChange"
                         v-model="company.details.name"
                         id="new-company-name"
                         name="Company name">
                  <span class="form-field-error" v-if="canEditDetails && this.errors.has('Company name')">{{ this.errors.first('Company name') }}</span>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="company-size" class="form-label color-2-63">Organisation size</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': canEditDetails && errors.has('Organisation size'), 'is-blocked': canEditDetails }]"
                         :disabled="true"
                         data-lpignore="true"
                         v-on:keyup="fieldChange"
                         v-model="company.details.companySize"
                         id="company-size"
                         name="Organisation size">
                  <span class="form-field-error" v-if="canEditDetails && this.errors.has('Organisation size')">{{ this.errors.first('Organisation size') }}</span>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="industry-sector" class="form-label color-2-63">Industry sector</label>
                  <v-select class="form-control form-control__select background-1-10-child border-1-10-child background-2-10-locked border-2-10-locked"
                            :class="[{ 'has-error': canEditDetails && errors.has('Industry sector'), 'is-locked': !canEditDetails, 'not-empty': company.details.industrySector !== null }]"
                            :disabled="canEditDetails === false"
                            :searchable="true"
                            :clearable="false"
                            v-model="company.details.industrySector"
                            :options="userIndustrySectors"
                            data-lpignore="true"
                            v-validate.persist="'required'"
                            name="Industry sector"
                            id="industry-sector"/>
                  <span class="form-field-error" v-if="canEditDetails && this.errors.has('Industry sector')">{{ this.errors.first('Industry sector') }}</span>
                </div>
              </div>
              <div class="form-group form-group-half" v-if="company.details.marketplace">
                <div class="form-element">
                  <label for="marketplace" class="form-label color-2-63">Marketplace</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': canEditDetails && errors.has('Marketplace'), 'is-blocked': canEditDetails }]"
                         :disabled="true"
                         data-lpignore="true"
                         v-on:keyup="fieldChange"
                         v-model="company.details.marketplace"
                         id="marketplace"
                         name="Marketplace">
                  <span class="form-field-error" v-if="canEditDetails && this.errors.has('Marketplace')">{{ this.errors.first('Marketplace') }}</span>
                </div>
              </div>
            </article>
            <div class="clearfix"></div>
            <div class="update-data update-data__details" v-if="canEditDetails && (getUserRole === 'ca' || getUserRole === 'ta')">
              <a href="#" v-on:click.prevent="closeEditDetails()" class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Discard changes</a>
              <a href="#" v-on:click.prevent="updateCompanyDetails()" class="save-edit background-1-100 color-2-100 save-edit-details">Save changes</a>
            </div>
          </div>
          <div class="content-section profile-section"
               :class="[{ 'content-section__bordered border-1-20': activeSection === 'companyOwner' || canEditOwner }]"
               tabindex="-1"
               ref="companyOwner">
            <article class="personal-info">
              <h3 class="content-section-title color-1-100 background-1-100-before">
                <template v-if="canEditOwner === false">Account owner details</template>
                <template v-else>Edit account owner details</template>
              </h3>
              <a href="#" v-on:click.prevent="openEditOwner()" class="edit-details edit-details-custom border-1-40 color-2-100"
                 v-if="canEditOwner === false && (getUserRole === 'ca' || getUserRole === 'ta')">
                  <span class="edit-icon color-1-100">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 12.955 12.921" style="enable-background:new 0 0 12.955 12.921;" xml:space="preserve">
                      <g id="XMLID_1_">
                        <path id="XMLID_4_" class="st0" d="M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921
                          c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"/>
                        <path id="XMLID_5_" class="st0" d="M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316
                          L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0
                          l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"/>
                      </g>
                    </svg>
                  </span>
                Edit
              </a>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="owner-first-name" class="form-label color-2-63">First name</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('First name'), 'is-locked': !canEditOwner, 'not-empty': company.ownerData.firstName !== '' }]"
                         :disabled="canEditOwner === false"
                         v-model="company.ownerData.firstName"
                         data-lpignore="true"
                         id="owner-first-name"
                         name="First name">
                  <span class="form-field-error" v-if="this.errors.has('First name')">{{ this.errors.first('First name') }}</span>
                </div>
                <div class="form-element">
                  <label for="owner-phone" class="form-label color-2-63">Phone number</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Phone number'), 'is-locked': !canEditOwner, 'not-empty': company.ownerData.phoneNumber !== '' }]"
                         :disabled="canEditOwner === false"
                         v-model="company.ownerData.phoneNumber"
                         data-lpignore="true"
                         id="owner-phone"
                         name="Phone number">
                  <span class="form-field-error" v-if="this.errors.has('Phone number')">{{ this.errors.first('Phone number') }}</span>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="owner-first-name" class="form-label color-2-63">Last name</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Last name'), 'is-locked': !canEditOwner, 'not-empty': company.ownerData.lastName !== '' }]"
                         :disabled="canEditOwner === false"
                         v-model="company.ownerData.lastName"
                         data-lpignore="true"
                         id="owner-last-name"
                         name="Last name">
                  <span class="form-field-error" v-if="this.errors.has('Last name')">{{ this.errors.first('Last name') }}</span>
                </div>
                <div class="form-element">
                  <label for="new-user-email" class="form-label color-2-63">Email</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Email'), 'is-locked': !canEditOwner, 'not-empty': company.ownerData.email !== '' }]"
                         :disabled="canEditOwner === false"
                         data-lpignore="true"
                         id="new-user-email"
                         v-validate="'email'"
                         name="Email"
                         v-model="company.ownerData.email"/>
                  <span class="form-field-error" v-if="this.errors.has('Email')">{{ this.errors.first('Email') }}</span>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="update-data update-data__details" v-if="canEditOwner && (getUserRole === 'ca' || getUserRole === 'ta')">
                <a href="#" v-on:click.prevent="closeEditOwner()" class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Discard changes</a>
                <a href="#" v-on:click.prevent="updateCompanyOwner()" class="save-edit background-1-100 color-2-100 save-edit-details">Save changes</a>
              </div>
            </article>
          </div>
          <div class="content-section profile-section"
               :class="[{ 'content-section__bordered border-1-20': activeSection === 'tasksSettings' || canEditTasksSettings }]"
               tabindex="-1"
               ref="tasksSettings">
            <article class="personal-info">
              <h3 class="content-section-title color-1-100 background-1-100-before">
                <template v-if="canEditTasksSettings === false">Task settings</template>
                <template v-else>Edit tasks settings</template>
              </h3>
              <button v-on:click.prevent="openTasksSettings()"
                      class="edit-details border-1-40 color-2-100"
                      v-if="canEditTasksSettings === false && getUserRole === 'ca'">Edit
              </button>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="company-contraption" class="form-label color-2-63">Company contraption</label>
                  <input type="text"
                         class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :disabled="canEditTasksSettings === false"
                         data-lpignore="true"
                         :class="[{ 'has-error': errors.has('Company contraption'), 'is-locked': !canEditTasksSettings, 'not-empty': company.tasksSettings.contraption !== '' }]"
                         id="company-contraption"
                         name="Company contraption"
                         v-model="company.tasksSettings.contraption"/>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="company-default-assignee" class="form-label color-2-63">Default assignee</label>
                  <v-select
                    class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                    :class="[{ 'has-error': errors.has('Default assignee'), 'is-locked': !canEditTasksSettings, 'not-empty': company.tasksSettings.defaultAssignee !== null }]"
                    :disabled="canEditTasksSettings === false"
                    :searchable=true
                    v-model="company.tasksSettings.defaultAssignee"
                    :options="defaultAssigneeForSelect"
                    data-vv-name="Default assignee"
                    data-lpignore="true"
                    name="Default assignee"
                    id="company-default-assignee"/>
                  <span class="form-field-error" v-if="this.errors.has('Default assignee')">{{ this.errors.first('Default assignee') }}</span>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="update-data update-data__details" v-if="canEditTasksSettings">
                <button v-on:click.prevent="closeEditTasksSettings()"
                        class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Discard changes
                </button>
                <button v-on:click.prevent="updateCompanyTasksSettings()"
                        class="save-edit background-1-100 color-2-100 save-edit-details">Save changes
                </button>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END:.profile -->
</template>

<script>
  import api from '@/api'
  import { mapActions, mapGetters } from 'vuex'
  import AppSelect from '@/components/admin/common/Select'

  export default {
    name: 'account-settings',
    data () {
      return {
        infMsgTitle: '',
        infMsgDescription: '',
        infMsgClass: '',
        messageDisplay: false,
        canEditDetails: false,
        canEditOwner: false,
        canEditTasksSettings: false,
        confOpened: null,
        company: {
          details: {
            id: '',
            name: '',
            industrySector: '',
            marketplace: '',
            companySize: ''
          },
          ownerData: {
            firstName: '',
            lastName: '',
            phoneNumber: '',
            email: ''
          },
          tasksSettings: {
            contraption: '',
            defaultAssignee: false,
            accountManager: false
          }
        },
        initialData: {
          details: {
            id: '',
            name: '',
            industrySector: '',
            marketplace: '',
            companySize: ''
          },
          ownerData: {
            firstName: '',
            lastName: '',
            phoneNumber: '',
            email: ''
          },
          tasksSettings: {
            contraption: '',
            defaultAssignee: false,
            accountManager: false
          }
        },
        confirmation: {
          action: '',
          isShown: false,
          articleId: null,
          i: null,
          style: {
            top: '100px'
          }
        },
        canLeave: false,
        next: null,
        isChanged: false,
        companyId: null,
        activeSection: 'companyDetails'
      }
    },
    computed: {
      ...mapGetters([
        'getUserRole',
        'getUserCompany',
        'getConfData',
        'userIndustrySectors',
        'defaultAssigneeForSelect'
      ])
    },
    methods: {
      ...mapActions([
        'clearConfAction',
        'setInformationMsg',
        'initConfAction',
        'authLogout',
        'getCompanyOrganizationTypes',
        'getTaskAssignee'
      ]),
      openEditEmails: function () {
        this.canEditEmails = true
      },
      openEditDetails: function () {
        this.canEditDetails = true
      },
      openEditOwner: function () {
        this.canEditOwner = true
      },
      openTasksSettings: function () {
        this.canEditTasksSettings = true
      },
      closeEditDetails: function () {
        this.company.details = this.initialData.details
        this.canEditDetails = false
        this.errors.clear()
      },
      closeEditOwner: function () {
        this.company.ownerData = this.initialData.ownerData
        this.canEditOwner = false
        this.errors.clear()
      },
      closeEditTasksSettings: function () {
        this.company.tasksSettings = this.initialData.tasksSettings
        this.canEditTasksSettings = false
        this.errors.clean()
      },
      closeMsg: function () {
        this.errors.clear()
      },
      fieldChange () {
        this.isChanged = true
      },
      getCompanyData () {
        this.$http.put(api.URLS.companyCreate, {id: this.companyId}, api.headersAuthSettings).then((res) => {
          let companyDetails = this.company
          // set received data
          companyDetails.details.id = res.body.id
          // company details
          companyDetails.details.name = res.body.name
          companyDetails.details.industrySector = res.body.industry_sector
          companyDetails.details.marketplace = res.body.industry !== null && res.body.industry.id !== 1 ? res.body.industry.name : ''
          companyDetails.details.companySize = res.body.company_size !== null ? res.body.company_size.name : null
          // company owner data
          companyDetails.ownerData.firstName = res.body.owner_first_name
          companyDetails.ownerData.lastName = res.body.owner_last_name
          companyDetails.ownerData.phoneNumber = res.body.owner_phone_number
          companyDetails.ownerData.email = res.body.owner_email
          // company task settings
          companyDetails.tasksSettings.contraption = res.body.contraption
          companyDetails.tasksSettings.defaultAssignee = null
          if (res.body.default_assignee !== null) {
            companyDetails.tasksSettings.defaultAssignee = {
              id: res.body.default_assignee.id,
              label: res.body.default_assignee.first_name + ' ' + res.body.default_assignee.last_name,
              value: res.body.default_assignee.id
            }
          }
          // set initial data
          this.initialData = companyDetails

          document.title = 'Account settings | Clear Assured'
          this.$store.commit('setUserDimensions')
          if (window._paq) {
            window._paq.push(['setCustomUrl', location.pathname])
            window._paq.push(['setDocumentTitle', document.title])
            window._paq.push(['trackPageView'])
          }
          // if (window.ga) {
          //   window.ga('set', 'contentGroup1', 'DASHBOARD_AREA')
          //   window.ga('send', 'pageview', {
          //     'page': location.pathname,
          //     'location': location.href,
          //     'title': document.title
          //   })
          // }
        }).catch((err) => {
          if (err.status === 404) {
            let props = this.$router.resolve({
              name: 'error'
            })
            this.$router.push(props.href)
          }
          if (err.status === 401) {
            this.authLogout()
          }
        })
      },
      updateCompanyDetails () {
        if (this.getUserRole !== 'ca') {
          return
        }
        if (this.disableAPI) return
        this.$validator.validateAll()
        if (this.errors.items.length) return
        let companyData = {
          id: this.company.details.id,
          companyName: this.company.details.name,
          industrySector: this.company.details.industrySector.label
        }
        this.disableAPI = true
        this.$http.put(api.URLS.companyCreate, companyData, api.headersAuthSettings)
            .then((res) => {
              this.disableAPI = false
              this.infMsgTitle = res.body.name + ' organisation details was successfully updated.'
              this.infMsgDescription = 'Please note all edits are being logged. '
              this.infMsgClass = 'success'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.getCompanyData()
              this.canEditDetails = !this.canEditDetails
            })
            .catch((err) => {
              this.disableAPI = false
              this.infMsgTitle = 'Error. We were not able to update this organisation because '
              for (let error in err.body.error.exception) {
                this.infMsgTitle += err.body.error.exception[error].message + ' '
              }
              this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
              this.infMsgClass = 'error'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.getCompanyData()
            })
      },
      updateCompanyOwner () {
        if (this.getUserRole !== 'ca') {
          return
        }
        if (this.disableAPI) return
        this.$validator.validateAll()
        if (this.errors.items.length) return
        let owner = {
          id: this.company.details.id,
          ownerFirstName: this.company.ownerData.firstName,
          ownerLastName: this.company.ownerData.lastName,
          ownerPhoneNumber: this.company.ownerData.phoneNumber,
          ownerEmail: this.company.ownerData.email
        }
        this.disableAPI = true
        this.$http.put(api.URLS.companyCreate, owner, api.headersAuthSettings)
            .then((res) => {
              this.disableAPI = false
              this.infMsgTitle = res.body.name + ' organisation owner details was successfully updated.'
              this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
              this.infMsgClass = 'success'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.getCompanyData()
              this.canEditOwner = !this.canEditOwner
            })
            .catch((err) => {
              this.disableAPI = false
              console.log('err', err)
              this.infMsgTitle = 'Error. We were not able to update this company because '
              for (let error in err.body.error.exception) {
                this.infMsgTitle += err.body.error.exception[error].message + ' '
              }
              this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
              this.infMsgClass = 'error'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.getCompanyData()
            })
      },
      updateCompanyTasksSettings () {
        if (this.getUserRole !== 'ca') {
          return
        }
        if (this.disableAPI) return
        this.$validator.validateAll()
        if (this.errors.items.length) return
        let companyData = {
          id: this.company.details.id,
          contraption: this.company.tasksSettings.contraption,
          defaultAssignee: this.company.tasksSettings.defaultAssignee
        }
        this.disableAPI = true
        this.$http.put(api.URLS.companyCreate, companyData, api.headersAuthSettings)
          .then((res) => {
            this.disableAPI = false
            this.infMsgTitle = res.body.name + ' company tasks settings was successfully updated.'
            this.infMsgDescription = 'Please note all edits are being logged. '
            this.infMsgClass = 'success'
            this.setInformationMsg({
              isShown: true,
              title: this.infMsgTitle,
              text: this.infMsgDescription,
              className: this.infMsgClass
            })
            this.getCompanyData()
            this.canEditTasksSettings = !this.canEditTasksSettings
          })
          .catch((err) => {
            this.disableAPI = false
            this.infMsgTitle = 'Error. We were not able to update this company because '
            for (let error in err.body.error.exception) {
              this.infMsgTitle += err.body.error.exception[error].message + ' '
            }
            this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
            this.infMsgClass = 'error'
            this.setInformationMsg({
              isShown: true,
              title: this.infMsgTitle,
              text: this.infMsgDescription,
              className: this.infMsgClass
            })
            this.getCompanyData()
          })
      },
      goToPageSection (ref) {
        let element = this.$refs[ref]
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
          setTimeout(function () {
            element.focus()
          })
        }
      },
      posY (elm) {
        let test = elm
        let top = 0
        while (test !== null && test.tagName.toLowerCase() !== 'body') {
          top += test.offsetTop
          test = test.offsetParent
        }
        return top
      },
      scrollY () {
        if (window.pageYOffset) {
          return window.pageYOffset
        }
        return Math.max(document.documentElement.scrollTop, document.body.scrollTop)
      },
      isScrolledIntoView (elem) {
        let docViewTop = this.scrollY()
        let docViewBottom = docViewTop + window.outerHeight
        let elemTop = this.posY(elem) + 300
        let elemBottom = elemTop + elem.offsetHeight
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop))
      },
      handleScroll () {
        let sections = this.$refs
        for (let index in sections) {
          let section = sections[index]
          if (section && this.isScrolledIntoView(section)) {
            this.activeSection = index
          }
        }
      }
    },
    components: {
      AppSelect
    },
    watch: {
      'getConfData.actionConfirmed' (value) {
        if (value) {
          if (this.confOpened === 'delete') this.deleteCompanyConfirmed()
          if (this.confOpened === 'archive') this.archiveCompanyConfirmed()
          this.clearConfAction()
        }
      }
    },
    created () {
      this.companyId = this.getUserCompany
      window.addEventListener('scroll', this.handleScroll)
    },
    mounted () {
      this.getCompanyData()
      this.getCompanyOrganizationTypes()
      this.getTaskAssignee()
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style src='@/assets/scss/components/profile.scss' lang='scss' />



// WEBPACK FOOTER //
// AccountSettings.vue?fb4533b6